import { JupyterLabWindow } from "@kaggle/jupyterlab";
import { whenExists } from "./whenExists";

/** Returns a promise that will resolve to JupyterLab API when ready. */
export const getJupyterLab = () => {
  const jlw = window as unknown as JupyterLabWindow;
  return whenExists(() => jlw.JupyterLab, 1000);
};
